module.exports = __webpack_public_path__ + "static/karta-platnicza-3c7fc40791a88df4f928f9e3f062a3a9.jpg";